import React from "react";
import "./MenuLayout.scss"
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
const MenuLayout = ({ data, layout = "layout1" }) => {
    const dispatch = useDispatch()
    return (
        <div className={layout === "layout1" ? "MenuLayout" : "MenuLayout2"}>
            <img className="Layout-image" alt="" src={data?.src} />
            <div className="Layout-flex">
                <div className="Layout-title">
                    {data?.name.toLowerCase()}
                </div>
                <div className="Layout-items">
                    {data?.items?.join(", ")}
                </div>
                <div className="Layout-button"
                    onClick={() => {
                        if (data?.href && data?.href?.includes("https://")) {
                            window.open(data?.href, '_blank')
                        } else {
                            dispatch(setIsComing(true))
                        }
                    }}>Click & Collect
                </div>
            </div>

        </div>
    )

}
export default MenuLayout